import React, { Component, Suspense } from "react";
import { Redirect } from "react-router-dom";
import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
// import Audit from "./../../../custom_modules/Audit.jsx";
import { withTranslation } from "react-multi-lang";
import Service from "./../../general/Service.jsx";
import "bootstrap";
import { withAlert } from "react-alert";
// import store from "./../../../redux_store/store/index";
import { isMultitenant } from "../../../custom_functions/Constance.jsx";
import { Button, Card, ModalFooter, } from "react-bootstrap";
import KendoCombobox from "../../../controls/KendoCombobox.jsx";
import { ContentPanel } from "../modules/samplestorage/product.styled.jsx";
import TreeViewEditable from "./form-tree-editable/form-tree-editable.component.jsx";

class StorageSelector extends Component {
  _isMounted = true;
  constructor(props) {
    super(props);

    this.ELNurl = window.appUrl.ELN;

    this.state = {
      jsonObject: undefined,
      editInventory: false,
      isMandatory: false,
      isGridView: false,
      isImportColumn: false,
      fieldName: undefined,
      fieldNameValidcls: "",
      storageList: [],
      selectedStorage: this.props.selectedRecord,
      treeDataView: undefined,
      selectedItemId: this.props.selectedRecord &&
        this.props.selectedRecord.storageid ? this.props.selectedRecord.storageid : undefined,
      selectedItem: this.props.selectedRecord &&
        this.props.selectedRecord.storageItem ? this.props.selectedRecord.storageItem : undefined,
      Data: [],
      dynamicControl: [],
      dynFieldArray: [],
      staticControl: [],
      selectedMaterialType: undefined,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    };
    this.dorender = true;
    this.inputref = React.createRef();
  }

  //  UNSAFE_componentWillReceiveProps(nextProps) { 
  //     if(nextProps !== undefined){ this.setState({isopen : nextProps.isOpen})}
  //   }

  componentDidMount() {
    this._isMounted = true;



    // if (selectedRecord !== undefined && selectedRecord !== null && selectedRecord.nmaterialinventorycode !== undefined) {
    //   if (this.ELNurl !== "") {
    //     let passObj = { "nmaterialinventorycode": selectedRecord.nmaterialinventorycode, "sitekey": Number(sessionStorage.Usersite) };

    //     this.setState({
    //       ServiceToUrl: "" + this.ELNurl + "/sampleStorage/getStorageIdBasedOnInvent",
    //       ServiceHeaderobject: passObj,
    //       ServiceMethodType: "POST",
    //       ServcieonSuccess: this.onGetStorageOnInventSuccess.bind(this),
    //       ServcieonFailure: this.onGetStorageFailure.bind(this),
    //     });
    //   }
    // } else {
    if (this.ELNurl !== "") {
      let passObj = { "sitekey": Number(sessionStorage.Usersite) };

      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/sampleStorage/getAllActiveSampleStorageLocation",
        ServiceHeaderobject: passObj,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.onGetStorageSuccess.bind(this),
        ServcieonFailure: this.onGetStorageFailure.bind(this),
      });
    }
    // }
  }

  onGetStorageOnInventSuccess(res) {
    if (res !== undefined && res !== null) {
      this.setState({
        storageList: res.sampleStorageLocation,
        selectedStorage: res.selectedSampleStorageLocation,
        treeDataView: JSON.parse(res.selectedSampleStorageVersion.jsonbresult),
        selectedItemId: res.selectedStorageId
      });
    }
  }

  onGetStorageSuccess(res) {
    console.log(res)
    if (res !== undefined && res !== null) {
      let { selectedRecord } = this.props;
      if (selectedRecord) {
        let treeview = selectedRecord.samplestoragelocationkey && selectedRecord.samplestoragelocationkey.sampleStorageVersion &&
          selectedRecord.samplestoragelocationkey.sampleStorageVersion.length > 0 && selectedRecord.samplestoragelocationkey.sampleStorageVersion[0]
          && selectedRecord.samplestoragelocationkey.sampleStorageVersion[0].jsonbresult && JSON.parse(selectedRecord.samplestoragelocationkey.sampleStorageVersion[0].jsonbresult)
        this.setState({
          storageList: res.sampleStorageLocation, selectedStorage: selectedRecord.samplestoragelocationkey,
          treeDataView: treeview, selectedItemId: selectedRecord.storageid
        });
      }
      else {
        this.setState({ storageList: res.sampleStorageLocation });
      }
    }

  }

  onChangeStorageLocation(val) {
    if (val !== undefined && val !== null) {
      this.setState({ selectedStorage: val });

      if (this.ELNurl !== "") {
        this.setState({
          ServiceToUrl: "" + this.ELNurl + "/sampleStorage/getActiveSampleStorageLocationByKey",
          ServiceHeaderobject: val,
          ServiceMethodType: "POST",
          ServcieonSuccess: this.onGetStorageLocationByKeySuccess.bind(this),
          ServcieonFailure: (res) => { },
        });
      }
    }
  }

  onGetStorageLocationByKeySuccess(res) {
    if (res !== undefined && res !== null) {
      if (res !== undefined && res !== null && res.selectedSampleStorageVersion !== undefined) {
        this.setState({ storageList: res.sampleStorageLocation, treeDataView: JSON.parse(res.selectedSampleStorageVersion.jsonbresult) })
      }
    } else {
      this.setState({ treeDataView: undefined })
    }
  }

  onGetStorageFailure(res) {
    console.log(res)
  }

  onHandleClose(res) {
    console.log(res)
    if (this.props.onHandleClose !== undefined) {
      this.props.onHandleClose()
    }
  }

  onSetStorageLocationOnInvnt(res) {
    console.log(res)
    if (this.state.selectedItemId !== undefined && this.state.selectedItemId !== null) {
      if (this.props.onSetStorageLocationOnInvnt !== undefined) {
        this.props.onSetStorageLocationOnInvnt(this.state.selectedStorage, this.state.selectedItem, this.state.treeDataView, this.props.activeindex);
      }
    } else {
      this.props.alert.error("Please select storage location node")
    }
  }

  shouldComponentUpdate(nextprop, nextstate) {
    if (!this.dorender) {
      return false;
    } else {
      return true;
    }
  }

  itemRenderView = (clickedItem) => {
    const { selectedItemId } = this.state;
    return (
      <>
        {clickedItem.item ? (
          <ul className="list-inline mb-0">
            <li className={`list-inline-item mr-3 ${selectedItemId === clickedItem.item.id ? 'selected-item' : ''}`}
              style={{
                backgroundColor: selectedItemId === clickedItem.item.id ? 'white' : 'transparent',
                border: selectedItemId === clickedItem.item.id ? '1px solid blue' : 'none',
                borderRadius: selectedItemId === clickedItem.item.id ? '4px' : '0',
                padding: selectedItemId === clickedItem.item.id ? '4px 8px' : '0',
                display: 'inline-flex', // To create a neat tag appearance
                alignItems: 'center', // To center the content vertically
              }}
            >
              {clickedItem.item.text}
            </li>
          </ul>
        ) : (
          ""
        )}
      </>
    );
  };

  onItemClickView = (event) => {
    this.setState({ selectedItemId: event.item.id, selectedItem: event.item })
  };

  onExpandChangeView = (event) => {
    event.item.expanded = !event.item.expanded;
  };
  
  render() {
    if (!sessionStorage.User) {
      return isMultitenant === 0 ? (
        <Redirect to="/" />
      ) : (
        <Redirect to={"/#" + sessionStorage.tenantdomain} />
      );
    }

    // Define a style object to add a border to the root div
    // const wrapperStyle = {
    //   border: "1px solid #ccc", // Adjust the border color and width as needed
    //   borderRadius: "4px", // Add border radius if desired
    // };

    return (
      <div className="sheets-wrapper" >
        <Service
          Tourl={this.state.ServiceToUrl}
          MethodType={this.state.ServiceMethodType}
          onSuccess={this.state.ServcieonSuccess}
          onFailure={this.state.ServcieonFailure}
          Headerobject={this.state.ServiceHeaderobject}
          onReseturl={() => { this.setState({ ServiceToUrl: "" }); }}
        />
        <div className="card-inner-body card-sm-padding bg-white">
          <Modal isOpen={true} className="screen-centered-scroll custom-modal">
            <ModalHeader className="modal-header">
              <h5>{this.props.t("Inventory.SampleStorage.IDS_LBL_STORAGEVIEWER")}</h5>
            </ModalHeader>
            <ModalBody>
              <div className="form-group mr-2">
                <Label className="required">{this.props.t("Inventory.SampleStorage.IDS_LBL_SLTSTORAGE")}</Label>
                <Suspense fallback={<div></div>}>
                  <KendoCombobox
                    initialValue=""
                    Datasource={(this?.state?.storageList?.filter(item => item.status === 1)) || []}
                    DefaultValue={this.state.selectedStorage}
                    onvaluechange={this.onChangeStorageLocation.bind(this)}
                    ValueMember="samplestoragelocationkey"
                    DisplayMember="samplestoragelocationname"
                    Placeholder={this.props.t("Inventory.SampleStorage.IDS_LBL_STORAGEVIEWER")}
                    additionalclass="clshideclearbutton"
                  />
                </Suspense>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <ContentPanel className="panel-main-content tree-full-view storagebuttonpopup">
                    {this.state.selectedStorage !== undefined && this.state.selectedStorage !== null && this.state.treeDataView !== undefined ? (
                      <Card className="border-0 mt-10 ml-10 tree-custom-style">
                        <Suspense fallback={<div></div>}>
                          <TreeViewEditable
                            id="samplestoragelocation"
                            name="samplestoragelocation"
                            label=""
                            placeholder="Enter samplestoragelocation"
                            data={this.state.treeDataView}
                            expandIcons={true}
                            item={e => this.itemRenderView(e)}
                            onExpandChange={e => this.onExpandChangeView(e)}
                            onItemClick={e => this.onItemClickView(e)}
                          />
                        </Suspense>
                      </Card>
                    ) : (
                      <></>
                    )}
                  </ContentPanel>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                id="id-saveStorageSelector"
                className="btn btn-user btn-primary-blue"
                onClick={this.onSetStorageLocationOnInvnt.bind(this)}
              >
                {this.props.t("Inventory.SampleStorage.IDS_BTN_SET")}
              </Button>
              <Button
                type="button"
                className="btn modalbluebtn button"
                data-dismiss="modal"
                onClick={this.onHandleClose.bind(this)}
              >
                {this.props.t("Inventory.SampleStorage.IDS_BTN_CANCEL")}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
        {/* <Audit
          AuditId="storageViewer"
          AuditUrl={this.state.AuditUrl}
          AuditObject={this.state.AuditObject}
          AuditPassfunction={this.state.AuditPassfunction}
          AuditFailfunction={this.state.AuditFailfunction}
          alert={this.props.alert}
        /> */}
      </div>
    );
  }
}
export default withAlert()(withTranslation(StorageSelector));